import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import FuelTypeSelect from '../FuelTypes/FuelTypeSelect';

const presetQuantities = [
  { value: 'none', label: 'none' },
  { value: 'gal', label: 'gal' },
  { value: 'top off', label: 'top off' },
  { value: 'to tabs', label: 'to tabs' },
  { value: 'to slots', label: 'to slots' },
];

const presetFuelOrderRequests = {
  orders: [
    {
      location: 'main', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'main', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'inboard', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'inboard', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'outboard', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'outboard', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'aux', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'aux', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'nac', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'nac', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'tip', position: 'right', quantity: undefined, type: 'none'
    },
    {
      location: 'tip', position: 'left', quantity: undefined, type: 'none'
    },
    {
      location: 'fusg', quantity: undefined, type: 'none'
    },
  ],
};

class FuelOrder extends Component {
  constructor(props) {
    super(props);

    // If we don't do this the presetFuelOrderRequests retain state infomation
    const copyOfPresetRequests = JSON.parse(JSON.stringify(presetFuelOrderRequests));
    const orderId = this.props.fuelOrder ? this.props.fuelOrder.orderId : 0;
    const fuelTypeId = this.props.fuelOrder ? this.props.fuelOrder.fuelTypeId : undefined;

    this.state = {
      fuelOrder: {
        orderId,
        fuelTypeId,
        request: copyOfPresetRequests,
      },
    };

    this.handleFuelTypeChange = this.handleFuelTypeChange.bind(this);
    this.selectOrderRequestChange = this.selectOrderRequestChange.bind(this);
    this.handleOrderRequestQuantityChange = this.handleOrderRequestQuantityChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fuelOrder) {
      const fuelOrder = JSON.parse(JSON.stringify(nextProps.fuelOrder));
      fuelOrder.fuelTypeId = fuelOrder.fuelTypeId ? fuelOrder.fuelTypeId : undefined;

      // make sure we always have a fuelOrder request
      if (fuelOrder.fuelTypeId && (fuelOrder.request === null || fuelOrder.request === undefined)) {
        fuelOrder.request = JSON.parse(JSON.stringify(presetFuelOrderRequests));
      }

      this.setState({ fuelOrder });
    }
  }

  clearOrder() {
    const clearedOrder = {
      orderId: 0,
      fuelTypeId: undefined,
      request: {},
    };
    this.setState({ fuelOrder: clearedOrder }, this.formChange());
  }

  formChange() {
    this.props.onFormChange(this.state.fuelOrder);
  }

  handleFuelTypeChange(value) {
    const fuelOrder = this.state.fuelOrder;
    fuelOrder.fuelTypeId = value;

    if (fuelOrder.fuelTypeId) {
      if (!fuelOrder.request.orders) {
        // reset the cleared orders
        fuelOrder.request = JSON.parse(JSON.stringify(presetFuelOrderRequests));
      }
      this.setState({ fuelOrder }, this.formChange());
    } else {
      this.clearOrder();
    }
  }

  handleOrderRequestQuantityChange(elementId, value) {
    const fuelOrder = this.state.fuelOrder;
    const orderRequest = fuelOrder.request.orders.find(element => `${element.location} ${element.position}` === elementId);
    orderRequest.quantity = value;
    fuelOrder.request.orders[elementId] = orderRequest;

    this.setState({ fuelOrder }, () => {
      this.formChange();
    });
  }

  selectOrderRequestChange(elementId, inputValue) {
    const fuelOrder = this.state.fuelOrder;
    const orderRequest = fuelOrder.request.orders.find(element => `${element.location} ${element.position}` === elementId);
    orderRequest.type = inputValue.value;
    fuelOrder.request.orders[elementId] = orderRequest;

    this.setState({ fuelOrder }, () => {
      this.formChange();
    });
  }

  renderOrderRequest(orderRequest) {
    const orderTypeClass = orderRequest.type === 'gal' ? 'gallon' : '';
    let positionClass = 'positionCenter';
    if (orderRequest.position === 'left') {
      positionClass = 'positionLeft';
    } else if (orderRequest.position === 'right') {
      positionClass = 'positionRight';
    }

    const selectId = `${orderRequest.location} ${orderRequest.position}`;
    return (<span key={selectId} className={`${orderRequest.location} ${positionClass} ${orderTypeClass}`} >
      {orderRequest.type === 'gal' &&
        <label className="galQuantity">
        Quantity<br />
          <input
            id="location"
            type="number"
            value={orderRequest.quantity}
            placeholder="0"
            onChange={e => this.handleOrderRequestQuantityChange(selectId, e.target.value)}
            onKeyDown={this.handleSubmitOnEnter}
          />
        </label>
        }
      <label className="locationSelection">
        {orderRequest.location} {orderRequest.position}<br />
        <Select
          id={selectId}
          name="fuel-order-select"
          value={orderRequest.type}
          options={presetQuantities}
          onChange={e => this.selectOrderRequestChange(selectId, e)}
          clearable={false}
        />
      </label>
    </span>);
  }

  renderOrderForm() {
    let orderForm = (
      this.state.fuelOrder.request.orders.map((orderRequest, i) =>
        this.renderOrderRequest(orderRequest))
    );

    if (!this.state.fuelOrder.request.orders) {
      orderForm = null;
    }

    return orderForm;
  }

  renderQuantity() {
    return (
      <label>
      Quantity<br />
        <input
          id="location"
          type="number"
          value={this.state.quantity}
          onChange={this.handleQuantityChange}
          onKeyDown={this.handleSubmitOnEnter} />
      </label>
    );
  }

  render() {
    return (
      <span className="fuelOrderForm">
        <label>
          Fuel Type <br />
          <FuelTypeSelect onSelectChange={this.handleFuelTypeChange} selectedValue={this.state.fuelOrder.fuelTypeId} fboId={this.props.fboId} />
        </label>
        <div className="fuel-order-locations">
        {this.state.fuelOrder.fuelTypeId &&
          this.renderOrderForm()
        }
        </div>
        <div className="clear"></div>
      </span>
    );
  }
}

FuelOrder.propTypes = {
  onFormChange: PropTypes.func.isRequired,
  fboId: PropTypes.number.isRequired,
  fuelOrder: PropTypes.shape({
    fuelTypeId: PropTypes.number.isRequired,
    request: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default FuelOrder;



// WEBPACK FOOTER //
// ./src/Containers/Orders/FuelOrder.js